<template>
  <div class="page" ref="pageContainer" @scroll="handleScroll">
    <!-- 我的项目操作 -->
    <div class="project">
      <div class="operation">
        <a-button type="primary" @click="$router.push('/project/add')"
          >新增</a-button
        >
        <a-input-search
          style="width: 200px"
          placeholder="请输入搜索关键字"
          v-model:value="keyword"
          enter-button
          @search="onSearch"
        />
      </div>
    </div>

    <div class="card-content">
      <div class="card-wrapper" v-for="item in dataSource" :key="item.id">
        <a-card hoverable class="card-item" @click="route(item.id)">
          <div class="card-box">
            <img
              :src="'https://picsum.photos/seed/' + item.id + '/260/130'"
            />
            <div class="name">{{ item.projectName }}</div>
          </div>
          <template class="ant-card-actions" #actions>
            <span>查看详情</span>
            <span @click.stop="$detail(item.id)">编辑</span>
          </template>
        </a-card>
      </div>
    </div>
    
    <div class="loading-more" v-if="loading">加载中...</div>
    <div class="no-more" v-if="noMore && dataSource.length > 0">没有更多了</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      targetName: "project",
      keyword: "",
      searchFile: "projectName",
      dataSource: [],
      loading: false,
      noMore: false,
      pageSize: 20,
      currentPage: 0,
    };
  },
  // 初始化数据
  async mounted() {
    await this.init();
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    // 初始化函数
    async init() {
      this.keyword = this.$route.query.keyword;
      this.currentPage = 0;
      this.noMore = false;
      this.dataSource = [];
      await this.loadMore();
    },
    
    async loadMore() {
      if (this.loading || this.noMore) return;
      
      this.loading = true;
      try {
        const count = await this.$loadList('createdAt', null, false, {
          append: this.currentPage > 0,
          limit: this.pageSize,
          skip: this.currentPage * this.pageSize
        });
        
        if (count < this.pageSize) {
          this.noMore = true;
        }
        this.currentPage++;
      } finally {
        this.loading = false;
      }
    },
    
    handleScroll(e) {
      const target = e.target;
      if (target.scrollHeight - target.scrollTop - target.clientHeight < 100) {
        this.loadMore();
      }
    },
    
    async onSearch() {
      await this.$setQuery("keyword", this.keyword);
      await this.init();
    },
    
    // 详情
    route(id) {
      this.$router.push({
        path: "/project/route",
        query: {
          id,
        },
      });
    },
    // 编辑
    edit(id) {
      this.$router.push({
        path: "/project/form",
        query: {
          id,
        },
      });
    },

    // 删除
    async onDelete(id) {
      let res = await new this.$lc.Query("project")
        .equalTo("objectId", id)
        .first();
       await res.destroy();
      this.$message.info(`删除成功`);
      this.init();
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  height: calc(100vh - 150px);
  overflow-y: auto;
}
.operation {
  display: flex;
  justify-content: space-between;
}
.card-content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  .card-wrapper {
    width: 25%;
    text-align: center;
  }
  .card-wrapper:nth-child(4n + 1) {
    text-align: left;
  }
  .card-wrapper:nth-child(4n + 4) {
    text-align: right;
  }

  .card-item {
    display: inline-block;
    width: 300px;
    margin: 0 0 20px;
    .card-box {
      display: flex;
      flex-direction: column;
      img {
        width: 100%;
        height: 130px;
      }
      .name {
        text-align: left;
        font-size: 18px;
        padding-top: 10px;
        margin-bottom: -10px;
      }
    }
  }
}
.loading-more, .no-more {
  text-align: center;
  padding: 20px;
  color: #999;
}
</style>
